/* Auto-derived from backend ApiEndpoints.json. Do not hand-edit endpoint paths without reconciling against backend source. */
export type CmtsHttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
export type CmtsEndpointParameter = { name: string; type: string; required: boolean };
export type CmtsBackendEndpoint = { key: string; controller: string; controllerGroup: string; action: string; method: CmtsHttpMethod; path: string; params: readonly CmtsEndpointParameter[]; frontendArea: string; risk: "core" | "admin" | "support" | "readiness"; };
export const CMTS_BACKEND_ENDPOINTS = [
  {
    key: "Access_Effective_GET_0", controller: "AccessController", controllerGroup: "Access", action: "Effective", method: "GET", path: "/access/effective",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Access_UserPermissions_GET_1", controller: "AccessController", controllerGroup: "Access", action: "UserPermissions", method: "GET", path: "/access/permissions/{userId}",
    params: [{"name": "userId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "EnterpriseAdminCrud_List_GET_2", controller: "EnterpriseAdminCrudController", controllerGroup: "EnterpriseAdminCrud", action: "List", method: "GET", path: "/admin/{masterType}",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "search", "type": "String", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseAdminCrud_Create_POST_3", controller: "EnterpriseAdminCrudController", controllerGroup: "EnterpriseAdminCrud", action: "Create", method: "POST", path: "/admin/{masterType}",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "request", "type": "AdminCrudUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseAdminCrud_Get_GET_4", controller: "EnterpriseAdminCrudController", controllerGroup: "EnterpriseAdminCrud", action: "Get", method: "GET", path: "/admin/{masterType}/{id}",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseAdminCrud_Update_PUT_5", controller: "EnterpriseAdminCrudController", controllerGroup: "EnterpriseAdminCrud", action: "Update", method: "PUT", path: "/admin/{masterType}/{id}",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "AdminCrudUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseAdminCrud_Deactivate_PATCH_6", controller: "EnterpriseAdminCrudController", controllerGroup: "EnterpriseAdminCrud", action: "Deactivate", method: "PATCH", path: "/admin/{masterType}/{id}/deactivate",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "MasterDeactivateRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminContract_Schema_GET_7", controller: "AdminContractController", controllerGroup: "AdminContract", action: "Schema", method: "GET", path: "/admin/{masterType}/schema",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminContract_Validate_POST_8", controller: "AdminContractController", controllerGroup: "AdminContract", action: "Validate", method: "POST", path: "/admin/{masterType}/validate",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "request", "type": "MasterValidationRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminCalendars_List_GET_9", controller: "AdminCalendarsController", controllerGroup: "AdminCalendars", action: "List", method: "GET", path: "/admin/calendars",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "pageNumber", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminCalendars_Create_POST_10", controller: "AdminCalendarsController", controllerGroup: "AdminCalendars", action: "Create", method: "POST", path: "/admin/calendars",
    params: [{"name": "dto", "type": "CalendarProfileUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminCalendars_Holidays_GET_11", controller: "AdminCalendarsController", controllerGroup: "AdminCalendars", action: "Holidays", method: "GET", path: "/admin/calendars/{id}/holidays",
    params: [{"name": "id", "type": "Guid", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminCalendars_Shifts_GET_12", controller: "AdminCalendarsController", controllerGroup: "AdminCalendars", action: "Shifts", method: "GET", path: "/admin/calendars/{id}/shifts",
    params: [{"name": "id", "type": "Guid", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminCalendars_WorkingDays_GET_13", controller: "AdminCalendarsController", controllerGroup: "AdminCalendars", action: "WorkingDays", method: "GET", path: "/admin/calendars/{id}/working-days",
    params: [{"name": "id", "type": "Guid", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminMasters_CreateCategory_POST_14", controller: "AdminMastersController", controllerGroup: "AdminMasters", action: "CreateCategory", method: "POST", path: "/admin/categories",
    params: [{"name": "request", "type": "MasterUpsertRequest", "required": true}, {"name": "parentCategoryId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "level", "type": "Int32", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Dependencies_GET_15", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Dependencies", method: "GET", path: "/admin/configuration/dependencies/{entityType}/{entityId}",
    params: [{"name": "entityType", "type": "String", "required": true}, {"name": "entityId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Export_POST_16", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Export", method: "POST", path: "/admin/configuration/export",
    params: [{"name": "request", "type": "ConfigurationExportRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_ImportApply_POST_17", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "ImportApply", method: "POST", path: "/admin/configuration/import/apply-to-draft",
    params: [{"name": "request", "type": "ConfigurationImportRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_ImportDryRun_POST_18", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "ImportDryRun", method: "POST", path: "/admin/configuration/import/dry-run",
    params: [{"name": "request", "type": "ConfigurationImportRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_SeedDryRun_POST_19", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "SeedDryRun", method: "POST", path: "/admin/configuration/seed-import/dry-run",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "seedRootPath", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_ValidateTenant_GET_20", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "ValidateTenant", method: "GET", path: "/admin/configuration/validate",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Versions_GET_21", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Versions", method: "GET", path: "/admin/configuration/versions",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_CreateVersion_POST_22", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "CreateVersion", method: "POST", path: "/admin/configuration/versions",
    params: [{"name": "request", "type": "ConfigurationVersionCreateRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Activate_POST_23", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Activate", method: "POST", path: "/admin/configuration/versions/{id}/activate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Approve_POST_24", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Approve", method: "POST", path: "/admin/configuration/versions/{id}/approve",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "ConfigurationDecisionRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Reject_POST_25", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Reject", method: "POST", path: "/admin/configuration/versions/{id}/reject",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "ConfigurationDecisionRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Rollback_POST_26", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Rollback", method: "POST", path: "/admin/configuration/versions/{id}/rollback",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Schedule_POST_27", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Schedule", method: "POST", path: "/admin/configuration/versions/{id}/schedule",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "effectiveFrom", "type": "DateTimeOffset", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Submit_POST_28", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Submit", method: "POST", path: "/admin/configuration/versions/{id}/submit",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ConfigurationGovernance_Validate_POST_29", controller: "ConfigurationGovernanceController", controllerGroup: "ConfigurationGovernance", action: "Validate", method: "POST", path: "/admin/configuration/versions/{id}/validate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminContract_Registry_GET_30", controller: "AdminContractController", controllerGroup: "AdminContract", action: "Registry", method: "GET", path: "/admin/master-registry",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminMasters_CreateReference_POST_31", controller: "AdminMastersController", controllerGroup: "AdminMasters", action: "CreateReference", method: "POST", path: "/admin/reference-values",
    params: [{"name": "request", "type": "MasterUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminMasters_UpdateReference_PUT_32", controller: "AdminMastersController", controllerGroup: "AdminMasters", action: "UpdateReference", method: "PUT", path: "/admin/reference-values/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "MasterUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminMasters_DeactivateReference_PATCH_33", controller: "AdminMastersController", controllerGroup: "AdminMasters", action: "DeactivateReference", method: "PATCH", path: "/admin/reference-values/{id}/deactivate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "MasterDeactivateRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminScheduledJobs_List_GET_34", controller: "AdminScheduledJobsController", controllerGroup: "AdminScheduledJobs", action: "List", method: "GET", path: "/admin/scheduled-jobs",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminScheduledJobs_Upsert_POST_35", controller: "AdminScheduledJobsController", controllerGroup: "AdminScheduledJobs", action: "Upsert", method: "POST", path: "/admin/scheduled-jobs",
    params: [{"name": "request", "type": "ScheduledJobDefinitionRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminScheduledJobs_RunNow_POST_36", controller: "AdminScheduledJobsController", controllerGroup: "AdminScheduledJobs", action: "RunNow", method: "POST", path: "/admin/scheduled-jobs/{id}/run-now",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminScheduledJobs_Runs_GET_37", controller: "AdminScheduledJobsController", controllerGroup: "AdminScheduledJobs", action: "Runs", method: "GET", path: "/admin/scheduled-jobs/{id}/runs",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AdminMasters_CreateTag_POST_38", controller: "AdminMastersController", controllerGroup: "AdminMasters", action: "CreateTag", method: "POST", path: "/admin/tags",
    params: [{"name": "request", "type": "MasterUpsertRequest", "required": true}, {"name": "tagType", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "AlertsApi_List_GET_39", controller: "AlertsApiController", controllerGroup: "AlertsApi", action: "List", method: "GET", path: "/alerts",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "pageNumber", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "AlertsApi_Acknowledge_POST_40", controller: "AlertsApiController", controllerGroup: "AlertsApi", action: "Acknowledge", method: "POST", path: "/alerts/{id}/acknowledge",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "AlertsApi_Resolve_POST_41", controller: "AlertsApiController", controllerGroup: "AlertsApi", action: "Resolve", method: "POST", path: "/alerts/{id}/resolve",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "AlertsApi_My_GET_42", controller: "AlertsApiController", controllerGroup: "AlertsApi", action: "My", method: "GET", path: "/alerts/my",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "pageNumber", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "AuditLogs_Get_GET_43", controller: "AuditLogsController", controllerGroup: "AuditLogs", action: "Get", method: "GET", path: "/audit-logs",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "entityType", "type": "String", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Auth_ChangePassword_POST_44", controller: "AuthController", controllerGroup: "Auth", action: "ChangePassword", method: "POST", path: "/auth/change-password",
    params: [{"name": "request", "type": "ChangePasswordRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_Login_POST_45", controller: "AuthController", controllerGroup: "Auth", action: "Login", method: "POST", path: "/auth/login",
    params: [{"name": "request", "type": "LoginRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_Logout_POST_46", controller: "AuthController", controllerGroup: "Auth", action: "Logout", method: "POST", path: "/auth/logout",
    params: [{"name": "request", "type": "LogoutRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_Me_GET_47", controller: "AuthController", controllerGroup: "Auth", action: "Me", method: "GET", path: "/auth/me",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_MyMenu_GET_48", controller: "AuthController", controllerGroup: "Auth", action: "MyMenu", method: "GET", path: "/auth/my-menu",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_MyOrganizationScope_GET_49", controller: "AuthController", controllerGroup: "Auth", action: "MyOrganizationScope", method: "GET", path: "/auth/my-organization-scope",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_MyPermissions_GET_50", controller: "AuthController", controllerGroup: "Auth", action: "MyPermissions", method: "GET", path: "/auth/my-permissions",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_RequestOtp_POST_51", controller: "AuthController", controllerGroup: "Auth", action: "RequestOtp", method: "POST", path: "/auth/otp/request",
    params: [{"name": "request", "type": "OtpRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_VerifyOtp_POST_52", controller: "AuthController", controllerGroup: "Auth", action: "VerifyOtp", method: "POST", path: "/auth/otp/verify",
    params: [{"name": "request", "type": "OtpVerifyRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_Refresh_POST_53", controller: "AuthController", controllerGroup: "Auth", action: "Refresh", method: "POST", path: "/auth/refresh",
    params: [{"name": "request", "type": "RefreshTokenRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_Sessions_GET_54", controller: "AuthController", controllerGroup: "Auth", action: "Sessions", method: "GET", path: "/auth/sessions",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Auth_RevokeSession_POST_55", controller: "AuthController", controllerGroup: "Auth", action: "RevokeSession", method: "POST", path: "/auth/sessions/{sessionId}/revoke",
    params: [{"name": "sessionId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Calendar_AddDuration_GET_56", controller: "CalendarController", controllerGroup: "Calendar", action: "AddDuration", method: "GET", path: "/calendar/{calendarProfileId}/add-duration",
    params: [{"name": "calendarProfileId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "start", "type": "DateTimeOffset", "required": false}, {"name": "minutes", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Calendar_IsWorkingTime_GET_57", controller: "CalendarController", controllerGroup: "Calendar", action: "IsWorkingTime", method: "GET", path: "/calendar/{calendarProfileId}/is-working-time",
    params: [{"name": "calendarProfileId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "at", "type": "DateTimeOffset", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "CalendarCalculation_CalculateDueDate_POST_58", controller: "CalendarCalculationController", controllerGroup: "CalendarCalculation", action: "CalculateDueDate", method: "POST", path: "/calendar/calculate-due-date",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "calendarProfileId", "type": "Guid", "required": false}, {"name": "start", "type": "DateTimeOffset", "required": false}, {"name": "durationMinutes", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Capa_Initiate_POST_59", controller: "CapaController", controllerGroup: "Capa", action: "Initiate", method: "POST", path: "/capa",
    params: [{"name": "request", "type": "CapaCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Capa_List_GET_60", controller: "CapaController", controllerGroup: "Capa", action: "List", method: "GET", path: "/capa/complaint/{complaintId}",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Capa_Complete_POST_61", controller: "CapaController", controllerGroup: "Capa", action: "Complete", method: "POST", path: "/capa/complaint/{complaintId}/{capaId}/complete",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "capaId", "type": "Guid", "required": true}, {"name": "request", "type": "CapaCompleteRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Categories_Get_GET_62", controller: "CategoriesController", controllerGroup: "Categories", action: "Get", method: "GET", path: "/categories",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Comments_Add_POST_63", controller: "CommentsController", controllerGroup: "Comments", action: "Add", method: "POST", path: "/comments",
    params: [{"name": "request", "type": "CommentCreateRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Comments_List_GET_64", controller: "CommentsController", controllerGroup: "Comments", action: "List", method: "GET", path: "/comments/complaint/{complaintId}",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_Get_GET_65", controller: "ComplaintsController", controllerGroup: "Complaints", action: "Get", method: "GET", path: "/complaints",
    params: [{"name": "TenantId", "type": "Guid", "required": false}, {"name": "Search", "type": "String", "required": false}, {"name": "SourceId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "CategoryId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "SeverityId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "StatusId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "SlaStateId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "OrganizationUnitId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "OwnerId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "FromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "ToDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "Page", "type": "Int32", "required": false}, {"name": "PageSize", "type": "Int32", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_Create_POST_66", controller: "ComplaintsController", controllerGroup: "Complaints", action: "Create", method: "POST", path: "/complaints",
    params: [{"name": "request", "type": "ComplaintCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_Capa_GET_67", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "Capa", method: "GET", path: "/complaints/{complaintId}/capa",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_CreateCapa_POST_68", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "CreateCapa", method: "POST", path: "/complaints/{complaintId}/capa",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "request", "type": "CapaCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_CompleteCapa_POST_69", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "CompleteCapa", method: "POST", path: "/complaints/{complaintId}/capa/{capaId}/complete",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "capaId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "CapaCompleteRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_Comments_GET_70", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "Comments", method: "GET", path: "/complaints/{complaintId}/comments",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_AddComment_POST_71", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "AddComment", method: "POST", path: "/complaints/{complaintId}/comments",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "CommentCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_Messages_GET_72", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "Messages", method: "GET", path: "/complaints/{complaintId}/messages",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_AddMessage_POST_73", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "AddMessage", method: "POST", path: "/complaints/{complaintId}/messages",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "MessageCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_Rca_GET_74", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "Rca", method: "GET", path: "/complaints/{complaintId}/rca",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_CreateRca_POST_75", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "CreateRca", method: "POST", path: "/complaints/{complaintId}/rca",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "request", "type": "RcaCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_CompleteRca_POST_76", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "CompleteRca", method: "POST", path: "/complaints/{complaintId}/rca/{rcaId}/complete",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "rcaId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "RcaCompleteRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_Tasks_GET_77", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "Tasks", method: "GET", path: "/complaints/{complaintId}/tasks",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_ApproveVerification_POST_78", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "ApproveVerification", method: "POST", path: "/complaints/{complaintId}/verification/{verificationId}/approve",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "verificationId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "VerificationDecisionRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_RejectVerification_POST_79", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "RejectVerification", method: "POST", path: "/complaints/{complaintId}/verification/{verificationId}/reject",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "verificationId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "VerificationDecisionRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ComplaintSubresourceRoutes_PrepareVerification_POST_80", controller: "ComplaintSubresourceRoutesController", controllerGroup: "ComplaintSubresourceRoutes", action: "PrepareVerification", method: "POST", path: "/complaints/{complaintId}/verification/prepare",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "request", "type": "VerificationPrepareRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_GetById_GET_81", controller: "ComplaintsController", controllerGroup: "Complaints", action: "GetById", method: "GET", path: "/complaints/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_Allowed_GET_82", controller: "ComplaintsController", controllerGroup: "Complaints", action: "Allowed", method: "GET", path: "/complaints/{id}/allowed-actions",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_Action_POST_83", controller: "ComplaintsController", controllerGroup: "Complaints", action: "Action", method: "POST", path: "/complaints/{id}/workflow-actions/{actionCode}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "actionCode", "type": "String", "required": true}, {"name": "body", "type": "WorkflowActionRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Complaints_GetByCode_GET_84", controller: "ComplaintsController", controllerGroup: "Complaints", action: "GetByCode", method: "GET", path: "/complaints/by-code/{complaintCode}",
    params: [{"name": "complaintCode", "type": "String", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "EnterpriseConfigurationGovernance_Audit_GET_85", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Audit", method: "GET", path: "/configuration-governance/audit",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Drafts_GET_86", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Drafts", method: "GET", path: "/configuration-governance/drafts",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Draft_GET_87", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Draft", method: "GET", path: "/configuration-governance/drafts/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Activate_POST_88", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Activate", method: "POST", path: "/configuration-governance/drafts/{id}/activate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Approve_POST_89", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Approve", method: "POST", path: "/configuration-governance/drafts/{id}/approve",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "ConfigurationDecisionDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_DependencyCheck_POST_90", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "DependencyCheck", method: "POST", path: "/configuration-governance/drafts/{id}/dependency-check",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Reject_POST_91", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Reject", method: "POST", path: "/configuration-governance/drafts/{id}/reject",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "ConfigurationDecisionDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Schedule_POST_92", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Schedule", method: "POST", path: "/configuration-governance/drafts/{id}/schedule",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "ConfigurationScheduleRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Submit_POST_93", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Submit", method: "POST", path: "/configuration-governance/drafts/{id}/submit",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Validate_POST_94", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Validate", method: "POST", path: "/configuration-governance/drafts/{id}/validate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Export_POST_95", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Export", method: "POST", path: "/configuration-governance/export",
    params: [{"name": "request", "type": "ConfigurationGovernanceExportRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_ImportDraft_POST_96", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "ImportDraft", method: "POST", path: "/configuration-governance/import-draft",
    params: [{"name": "request", "type": "ConfigurationImportDraftRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_MaterializationLogs_GET_97", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "MaterializationLogs", method: "GET", path: "/configuration-governance/materialization-logs",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_RollbackSnapshots_GET_98", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "RollbackSnapshots", method: "GET", path: "/configuration-governance/rollback-snapshots",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Versions_GET_99", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Versions", method: "GET", path: "/configuration-governance/versions",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EnterpriseConfigurationGovernance_Rollback_POST_100", controller: "EnterpriseConfigurationGovernanceController", controllerGroup: "EnterpriseConfigurationGovernance", action: "Rollback", method: "POST", path: "/configuration-governance/versions/{id}/rollback",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "ConfigurationRollbackRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Dashboard_Get_GET_101", controller: "DashboardController", controllerGroup: "Dashboard", action: "Get", method: "GET", path: "/dashboard",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "organizationUnitId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Configuration_GET_102", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Configuration", method: "GET", path: "/dashboards/configuration",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "dashboardType", "type": "String", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_ValidateConfiguration_POST_103", controller: "DashboardsController", controllerGroup: "Dashboards", action: "ValidateConfiguration", method: "POST", path: "/dashboards/configuration/validate",
    params: [{"name": "definitions", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Customer_GET_104", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Customer", method: "GET", path: "/dashboards/customer",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "externalPartyId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Department_GET_105", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Department", method: "GET", path: "/dashboards/department",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "organizationUnitId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "departmentId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Drilldown_POST_106", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Drilldown", method: "POST", path: "/dashboards/drilldown",
    params: [{"name": "request", "type": "DashboardDrilldownRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Export_POST_107", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Export", method: "POST", path: "/dashboards/export",
    params: [{"name": "request", "type": "DashboardExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Kpi_POST_108", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Kpi", method: "POST", path: "/dashboards/kpi/{kpiCode}",
    params: [{"name": "kpiCode", "type": "String", "required": true}, {"name": "request", "type": "DashboardRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Management_GET_109", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Management", method: "GET", path: "/dashboards/management",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Personal_GET_110", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Personal", method: "GET", path: "/dashboards/personal",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Query_POST_111", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Query", method: "POST", path: "/dashboards/query",
    params: [{"name": "request", "type": "DashboardRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Dashboards_Supplier_GET_112", controller: "DashboardsController", controllerGroup: "Dashboards", action: "Supplier", method: "GET", path: "/dashboards/supplier",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "externalPartyId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Escalation_Evaluate_POST_113", controller: "EscalationController", controllerGroup: "Escalation", action: "Evaluate", method: "POST", path: "/escalation/evaluate",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "EnterpriseEvents_Publish_POST_114", controller: "EnterpriseEventsController", controllerGroup: "EnterpriseEvents", action: "Publish", method: "POST", path: "/events",
    params: [{"name": "request", "type": "EnterpriseEventPublishRequest", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "EnterpriseEvents_Process_POST_115", controller: "EnterpriseEventsController", controllerGroup: "EnterpriseEvents", action: "Process", method: "POST", path: "/events/process-pending",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "EnterpriseEvents_Subscribe_POST_116", controller: "EnterpriseEventsController", controllerGroup: "EnterpriseEvents", action: "Subscribe", method: "POST", path: "/events/subscriptions",
    params: [{"name": "request", "type": "EventSubscriptionRequest", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "EvidenceAdministration_Quarantine_POST_117", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "Quarantine", method: "POST", path: "/evidence-administration/evidence/{id}/quarantine",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_Release_POST_118", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "Release", method: "POST", path: "/evidence-administration/evidence/{id}/release",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_Rescan_POST_119", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "Rescan", method: "POST", path: "/evidence-administration/evidence/{id}/rescan",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_Policies_GET_120", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "Policies", method: "GET", path: "/evidence-administration/policies",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_CreatePolicy_POST_121", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "CreatePolicy", method: "POST", path: "/evidence-administration/policies",
    params: [{"name": "request", "type": "EvidencePolicyUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_UpdatePolicy_PUT_122", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "UpdatePolicy", method: "PUT", path: "/evidence-administration/policies/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "EvidencePolicyUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_ActivatePolicy_POST_123", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "ActivatePolicy", method: "POST", path: "/evidence-administration/policies/{id}/activate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_ValidatePolicy_POST_124", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "ValidatePolicy", method: "POST", path: "/evidence-administration/policies/{id}/validate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_ScanHealth_GET_125", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "ScanHealth", method: "GET", path: "/evidence-administration/scan-health",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_ScanResults_GET_126", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "ScanResults", method: "GET", path: "/evidence-administration/scan-results",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "EvidenceAdministration_StorageHealth_GET_127", controller: "EvidenceAdministrationController", controllerGroup: "EvidenceAdministration", action: "StorageHealth", method: "GET", path: "/evidence-administration/storage-health",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "FieldDefinitions_Get_GET_128", controller: "FieldDefinitionsController", controllerGroup: "FieldDefinitions", action: "Get", method: "GET", path: "/field-definitions",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "FieldSchemas_Get_GET_129", controller: "FieldSchemasController", controllerGroup: "FieldSchemas", action: "Get", method: "GET", path: "/field-schemas",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "categoryId", "type": "Guid", "required": false}, {"name": "sourceId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "FieldSchemas_Validate_POST_130", controller: "FieldSchemasController", controllerGroup: "FieldSchemas", action: "Validate", method: "POST", path: "/field-schemas/validate",
    params: [{"name": "request", "type": "FieldSchemaValidationRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ApiContractHealth_Get_GET_131", controller: "ApiContractHealthController", controllerGroup: "ApiContractHealth", action: "Get", method: "GET", path: "/health/api-contract",
    params: [],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "Health_Integrity_GET_132", controller: "HealthController", controllerGroup: "Health", action: "Integrity", method: "GET", path: "/health/integrity",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "Health_SourceCompletionReview_GET_133", controller: "HealthController", controllerGroup: "Health", action: "SourceCompletionReview", method: "GET", path: "/health/source-completion-review",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "Health_StrictClosure_GET_134", controller: "HealthController", controllerGroup: "Health", action: "StrictClosure", method: "GET", path: "/health/strict-closure",
    params: [{"name": "repositoryRootPath", "type": "String", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "MasterDependency_Get_GET_135", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "Get", method: "GET", path: "/master-dependencies/{masterType}/{id}",
    params: [{"name": "masterType", "type": "String", "required": true}, {"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_Check_POST_136", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "Check", method: "POST", path: "/master-dependencies/check",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckActivation_POST_137", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckActivation", method: "POST", path: "/master-dependencies/check-activation",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckCircular_POST_138", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckCircular", method: "POST", path: "/master-dependencies/check-circular",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckDeactivate_POST_139", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckDeactivate", method: "POST", path: "/master-dependencies/check-deactivate",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckDelete_POST_140", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckDelete", method: "POST", path: "/master-dependencies/check-delete",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckImportDraft_POST_141", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckImportDraft", method: "POST", path: "/master-dependencies/check-import-draft",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckReadiness_POST_142", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckReadiness", method: "POST", path: "/master-dependencies/check-readiness",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckRollback_POST_143", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckRollback", method: "POST", path: "/master-dependencies/check-rollback",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_CheckSchedule_POST_144", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "CheckSchedule", method: "POST", path: "/master-dependencies/check-schedule",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "MasterDependency_Remediation_POST_145", controller: "MasterDependencyController", controllerGroup: "MasterDependency", action: "Remediation", method: "POST", path: "/master-dependencies/remediation",
    params: [{"name": "request", "type": "MasterDependencyGraphRequestDto", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Messages_Delete_DELETE_146", controller: "MessagesController", controllerGroup: "Messages", action: "Delete", method: "DELETE", path: "/messages/{messageId}",
    params: [{"name": "messageId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Messages_ComplaintMessages_GET_147", controller: "MessagesController", controllerGroup: "Messages", action: "ComplaintMessages", method: "GET", path: "/messages/complaint/{complaintId}",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Messages_Threads_GET_148", controller: "MessagesController", controllerGroup: "Messages", action: "Threads", method: "GET", path: "/messages/threads",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Messages_CreateThread_POST_149", controller: "MessagesController", controllerGroup: "Messages", action: "CreateThread", method: "POST", path: "/messages/threads",
    params: [{"name": "request", "type": "MessageThreadCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Messages_AddMessage_POST_150", controller: "MessagesController", controllerGroup: "Messages", action: "AddMessage", method: "POST", path: "/messages/threads/{threadId}",
    params: [{"name": "threadId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "request", "type": "MessageCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Migration_Run_POST_151", controller: "MigrationController", controllerGroup: "Migration", action: "Run", method: "POST", path: "/migration/legacy/run",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "requestedBy", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "NotificationProvider_List_GET_152", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "List", method: "GET", path: "/notification-providers",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Create_POST_153", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Create", method: "POST", path: "/notification-providers",
    params: [{"name": "request", "type": "NotificationProviderUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Get_GET_154", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Get", method: "GET", path: "/notification-providers/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Update_PUT_155", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Update", method: "PUT", path: "/notification-providers/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "NotificationProviderUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Activate_POST_156", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Activate", method: "POST", path: "/notification-providers/{id}/activate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Deactivate_POST_157", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Deactivate", method: "POST", path: "/notification-providers/{id}/deactivate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Health_GET_158", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Health", method: "GET", path: "/notification-providers/{id}/health",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_TestDispatch_POST_159", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "TestDispatch", method: "POST", path: "/notification-providers/{id}/test-dispatch",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "request", "type": "NotificationProviderTestDispatchRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Validate_POST_160", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Validate", method: "POST", path: "/notification-providers/{id}/validate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_DispatchAttempts_GET_161", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "DispatchAttempts", method: "GET", path: "/notification-providers/dispatch-attempts",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "status", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationProvider_Retry_POST_162", controller: "NotificationProviderController", controllerGroup: "NotificationProvider", action: "Retry", method: "POST", path: "/notification-providers/dispatch-attempts/{id}/retry",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationsApi_MarkRead_POST_163", controller: "NotificationsApiController", controllerGroup: "NotificationsApi", action: "MarkRead", method: "POST", path: "/notifications/{id}/mark-read",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "NotificationDispatch_ChannelHealth_GET_164", controller: "NotificationDispatchController", controllerGroup: "NotificationDispatch", action: "ChannelHealth", method: "GET", path: "/notifications/channel-health",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationDispatch_Dispatch_POST_165", controller: "NotificationDispatchController", controllerGroup: "NotificationDispatch", action: "Dispatch", method: "POST", path: "/notifications/dispatch-pending",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "NotificationsApi_My_GET_166", controller: "NotificationsApiController", controllerGroup: "NotificationsApi", action: "My", method: "GET", path: "/notifications/my",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "pageNumber", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "NotificationDispatch_UpsertTemplate_POST_167", controller: "NotificationDispatchController", controllerGroup: "NotificationDispatch", action: "UpsertTemplate", method: "POST", path: "/notifications/templates",
    params: [{"name": "request", "type": "NotificationTemplateUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "OperationalReadiness_NormalizeActionPayload_POST_168", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "NormalizeActionPayload", method: "POST", path: "/operational-readiness/actions/normalize-payload",
    params: [{"name": "request", "type": "ActionPayloadNormalizationRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_ClassifyDomain_POST_169", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "ClassifyDomain", method: "POST", path: "/operational-readiness/classification/domain",
    params: [{"name": "request", "type": "DomainClassificationRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_CompletenessChecklist_GET_170", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "CompletenessChecklist", method: "GET", path: "/operational-readiness/completeness-checklist",
    params: [],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_CalculateDashboard_POST_171", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "CalculateDashboard", method: "POST", path: "/operational-readiness/dashboard/calculate",
    params: [{"name": "request", "type": "DashboardRequestDto", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateEvidenceDownload_POST_172", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateEvidenceDownload", method: "POST", path: "/operational-readiness/evidence/evaluate-download",
    params: [{"name": "request", "type": "EvidenceAccessRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateEvidencePackageExport_POST_173", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateEvidencePackageExport", method: "POST", path: "/operational-readiness/evidence/evaluate-package-export",
    params: [{"name": "request", "type": "EvidencePackageExportRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_ValidateEvidenceSecurity_POST_174", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "ValidateEvidenceSecurity", method: "POST", path: "/operational-readiness/evidence/validate-security",
    params: [{"name": "request", "type": "EvidenceSecurityRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_LifecycleScenarios_GET_175", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "LifecycleScenarios", method: "GET", path: "/operational-readiness/lifecycle-scenarios",
    params: [],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateMessageVisibility_POST_176", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateMessageVisibility", method: "POST", path: "/operational-readiness/messages/evaluate-visibility",
    params: [{"name": "request", "type": "MessageVisibilityRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_NotificationChannelHealth_POST_177", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "NotificationChannelHealth", method: "POST", path: "/operational-readiness/notifications/channel-health",
    params: [{"name": "channelConfigs", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_DispatchNotification_POST_178", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "DispatchNotification", method: "POST", path: "/operational-readiness/notifications/dispatch",
    params: [{"name": "request", "type": "NotificationDispatchRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_OperationalReadinessReport_GET_179", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "OperationalReadinessReport", method: "GET", path: "/operational-readiness/operational-readiness-report",
    params: [],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_AgeingReport_POST_180", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "AgeingReport", method: "POST", path: "/operational-readiness/reports/ageing",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_ClosureVerificationReport_POST_181", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "ClosureVerificationReport", method: "POST", path: "/operational-readiness/reports/closure-verification",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_CustomerComplaintReport_POST_182", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "CustomerComplaintReport", method: "POST", path: "/operational-readiness/reports/customer-complaint",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_DepartmentPerformanceReport_POST_183", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "DepartmentPerformanceReport", method: "POST", path: "/operational-readiness/reports/department-performance",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_RcaCapaLinkageReport_POST_184", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "RcaCapaLinkageReport", method: "POST", path: "/operational-readiness/reports/rca-capa-linkage",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_SlaBreachReport_POST_185", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "SlaBreachReport", method: "POST", path: "/operational-readiness/reports/sla-breach",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_SupplierComplaintReport_POST_186", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "SupplierComplaintReport", method: "POST", path: "/operational-readiness/reports/supplier-complaint",
    params: [{"name": "request", "type": "0, Culture=neutral, PublicKeyToken=null]]", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_TypedReportContracts_GET_187", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "TypedReportContracts", method: "GET", path: "/operational-readiness/reports/typed-contracts",
    params: [],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateSla_POST_188", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateSla", method: "POST", path: "/operational-readiness/sla/evaluate",
    params: [{"name": "request", "type": "SlaEvaluationRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateClosureReadiness_POST_189", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateClosureReadiness", method: "POST", path: "/operational-readiness/workflow/evaluate-closure-readiness",
    params: [{"name": "request", "type": "ClosureReadinessRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OperationalReadiness_EvaluateTransition_POST_190", controller: "OperationalReadinessController", controllerGroup: "OperationalReadiness", action: "EvaluateTransition", method: "POST", path: "/operational-readiness/workflow/evaluate-transition",
    params: [{"name": "request", "type": "WorkflowTransitionEvaluationRequest", "required": true}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "OrganizationUnits_Deactivate_PATCH_191", controller: "OrganizationUnitsController", controllerGroup: "OrganizationUnits", action: "Deactivate", method: "PATCH", path: "/organization-units/{id}/deactivate",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "OrganizationUnits_Tree_GET_192", controller: "OrganizationUnitsController", controllerGroup: "OrganizationUnits", action: "Tree", method: "GET", path: "/organization-units/tree",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Permissions_Get_GET_193", controller: "PermissionsController", controllerGroup: "Permissions", action: "Get", method: "GET", path: "/permissions",
    params: [{"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Rca_Initiate_POST_194", controller: "RcaController", controllerGroup: "Rca", action: "Initiate", method: "POST", path: "/rca",
    params: [{"name": "request", "type": "RcaCreateRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Rca_List_GET_195", controller: "RcaController", controllerGroup: "Rca", action: "List", method: "GET", path: "/rca/complaint/{complaintId}",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Rca_Complete_POST_196", controller: "RcaController", controllerGroup: "Rca", action: "Complete", method: "POST", path: "/rca/complaint/{complaintId}/{rcaId}/complete",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "rcaId", "type": "Guid", "required": true}, {"name": "request", "type": "RcaCompleteRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "ReferenceBootstrap_Bootstrap_GET_197", controller: "ReferenceBootstrapController", controllerGroup: "ReferenceBootstrap", action: "Bootstrap", method: "GET", path: "/reference/bootstrap",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ReferenceBootstrap_Types_GET_198", controller: "ReferenceBootstrapController", controllerGroup: "ReferenceBootstrap", action: "Types", method: "GET", path: "/reference/types",
    params: [],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Reference_Values_GET_199", controller: "ReferenceController", controllerGroup: "Reference", action: "Values", method: "GET", path: "/reference/values",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "typeCode", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Reminders_Send_POST_200", controller: "RemindersController", controllerGroup: "Reminders", action: "Send", method: "POST", path: "/reminders/{id}/send",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reminders_Evaluate_POST_201", controller: "RemindersController", controllerGroup: "Reminders", action: "Evaluate", method: "POST", path: "/reminders/evaluate-due",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "ReportExports_Create_POST_202", controller: "ReportExportsController", controllerGroup: "ReportExports", action: "Create", method: "POST", path: "/report-exports",
    params: [{"name": "request", "type": "ReportExportCreateRequest", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "ReportExports_Get_GET_203", controller: "ReportExportsController", controllerGroup: "ReportExports", action: "Get", method: "GET", path: "/report-exports/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "ReportExports_Download_GET_204", controller: "ReportExportsController", controllerGroup: "ReportExports", action: "Download", method: "GET", path: "/report-exports/{id}/download",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_Ageing_POST_205", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "Ageing", method: "POST", path: "/report-exports/ageing",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_ClosureVerification_POST_206", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "ClosureVerification", method: "POST", path: "/report-exports/closure-verification",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_CustomerComplaints_POST_207", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "CustomerComplaints", method: "POST", path: "/report-exports/customer-complaints",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_DepartmentPerformance_POST_208", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "DepartmentPerformance", method: "POST", path: "/report-exports/department-performance",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_RcaCapaLinkage_POST_209", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "RcaCapaLinkage", method: "POST", path: "/report-exports/rca-capa-linkage",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_SlaBreach_POST_210", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "SlaBreach", method: "POST", path: "/report-exports/sla-breach",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_SupplierComplaints_POST_211", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "SupplierComplaints", method: "POST", path: "/report-exports/supplier-complaints",
    params: [{"name": "request", "type": "TypedReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_Get_GET_212", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "Get", method: "GET", path: "/report-exports/typed/{id}",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReportExports_Download_GET_213", controller: "TypedReportExportsController", controllerGroup: "TypedReportExports", action: "Download", method: "GET", path: "/report-exports/typed/{id}/download",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Ageing_GET_214", controller: "ReportsController", controllerGroup: "Reports", action: "Ageing", method: "GET", path: "/reports/ageing",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_Ageing_POST_215", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "Ageing", method: "POST", path: "/reports/ageing/query",
    params: [{"name": "request", "type": "AgeingReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_AuditLog_GET_216", controller: "ReportsController", controllerGroup: "Reports", action: "AuditLog", method: "GET", path: "/reports/audit-log",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_CategoryWise_GET_217", controller: "ReportsController", controllerGroup: "Reports", action: "CategoryWise", method: "GET", path: "/reports/category-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_ClosureVerification_GET_218", controller: "ReportsController", controllerGroup: "Reports", action: "ClosureVerification", method: "GET", path: "/reports/closure-verification",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_ClosureVerification_POST_219", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "ClosureVerification", method: "POST", path: "/reports/closure-verification/query",
    params: [{"name": "request", "type": "ClosureVerificationReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_ComplaintRegister_GET_220", controller: "ReportsController", controllerGroup: "Reports", action: "ComplaintRegister", method: "GET", path: "/reports/complaint-register",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_UpsertConfiguration_POST_221", controller: "ReportsController", controllerGroup: "Reports", action: "UpsertConfiguration", method: "POST", path: "/reports/configurations",
    params: [{"name": "request", "type": "ReportConfigurationUpsertRequest", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Customer_GET_222", controller: "ReportsController", controllerGroup: "Reports", action: "Customer", method: "GET", path: "/reports/customer",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Customer_GET_223", controller: "ReportsController", controllerGroup: "Reports", action: "Customer", method: "GET", path: "/reports/customer-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_CustomerComplaints_POST_224", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "CustomerComplaints", method: "POST", path: "/reports/customer-complaints/query",
    params: [{"name": "request", "type": "CustomerComplaintReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_DepartmentPerformance_POST_225", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "DepartmentPerformance", method: "POST", path: "/reports/department-performance/query",
    params: [{"name": "request", "type": "DepartmentPerformanceReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_DepartmentWise_GET_226", controller: "ReportsController", controllerGroup: "Reports", action: "DepartmentWise", method: "GET", path: "/reports/department-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Export_POST_227", controller: "ReportsController", controllerGroup: "Reports", action: "Export", method: "POST", path: "/reports/export",
    params: [{"name": "request", "type": "ReportExportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_ManagementSummary_GET_228", controller: "ReportsController", controllerGroup: "Reports", action: "ManagementSummary", method: "GET", path: "/reports/management-summary",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_NearBreach_GET_229", controller: "ReportsController", controllerGroup: "Reports", action: "NearBreach", method: "GET", path: "/reports/near-breach",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_OpenComplaints_GET_230", controller: "ReportsController", controllerGroup: "Reports", action: "OpenComplaints", method: "GET", path: "/reports/open-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_OwnerWise_GET_231", controller: "ReportsController", controllerGroup: "Reports", action: "OwnerWise", method: "GET", path: "/reports/owner-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_PlantWise_GET_232", controller: "ReportsController", controllerGroup: "Reports", action: "PlantWise", method: "GET", path: "/reports/plant-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_RcaCapa_GET_233", controller: "ReportsController", controllerGroup: "Reports", action: "RcaCapa", method: "GET", path: "/reports/rca-capa-linkage",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_RcaCapaLinkage_POST_234", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "RcaCapaLinkage", method: "POST", path: "/reports/rca-capa-linkage/query",
    params: [{"name": "request", "type": "RcaCapaLinkageReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Reopen_GET_235", controller: "ReportsController", controllerGroup: "Reports", action: "Reopen", method: "GET", path: "/reports/reopen",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Repeat_GET_236", controller: "ReportsController", controllerGroup: "Reports", action: "Repeat", method: "GET", path: "/reports/repeat",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Repeat_GET_237", controller: "ReportsController", controllerGroup: "Reports", action: "Repeat", method: "GET", path: "/reports/repeat-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_SeverityWise_GET_238", controller: "ReportsController", controllerGroup: "Reports", action: "SeverityWise", method: "GET", path: "/reports/severity-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_SlaBreach_GET_239", controller: "ReportsController", controllerGroup: "Reports", action: "SlaBreach", method: "GET", path: "/reports/sla-breach",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_SlaBreach_POST_240", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "SlaBreach", method: "POST", path: "/reports/sla-breach/query",
    params: [{"name": "request", "type": "SlaBreachReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_SourceWise_GET_241", controller: "ReportsController", controllerGroup: "Reports", action: "SourceWise", method: "GET", path: "/reports/source-wise",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Supplier_GET_242", controller: "ReportsController", controllerGroup: "Reports", action: "Supplier", method: "GET", path: "/reports/supplier",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_Supplier_GET_243", controller: "ReportsController", controllerGroup: "Reports", action: "Supplier", method: "GET", path: "/reports/supplier-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "TypedReports_SupplierComplaints_POST_244", controller: "TypedReportsController", controllerGroup: "TypedReports", action: "SupplierComplaints", method: "POST", path: "/reports/supplier-complaints/query",
    params: [{"name": "request", "type": "SupplierComplaintReportRequestDto", "required": true}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_AgeingTyped_GET_245", controller: "ReportsController", controllerGroup: "Reports", action: "AgeingTyped", method: "GET", path: "/reports/typed/ageing",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_ClosureVerificationTyped_GET_246", controller: "ReportsController", controllerGroup: "Reports", action: "ClosureVerificationTyped", method: "GET", path: "/reports/typed/closure-verification",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_CustomerComplaintTyped_GET_247", controller: "ReportsController", controllerGroup: "Reports", action: "CustomerComplaintTyped", method: "GET", path: "/reports/typed/customer-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_DepartmentPerformanceTyped_GET_248", controller: "ReportsController", controllerGroup: "Reports", action: "DepartmentPerformanceTyped", method: "GET", path: "/reports/typed/department-performance",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "organizationUnitId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_RcaCapaLinkageTyped_GET_249", controller: "ReportsController", controllerGroup: "Reports", action: "RcaCapaLinkageTyped", method: "GET", path: "/reports/typed/rca-capa-linkage",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_SlaBreachTyped_GET_250", controller: "ReportsController", controllerGroup: "Reports", action: "SlaBreachTyped", method: "GET", path: "/reports/typed/sla-breach",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Reports_SupplierComplaintTyped_GET_251", controller: "ReportsController", controllerGroup: "Reports", action: "SupplierComplaintTyped", method: "GET", path: "/reports/typed/supplier-complaints",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "fromDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "toDate", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "page", "type": "Int32", "required": false}, {"name": "pageSize", "type": "Int32", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Roles_Get_GET_252", controller: "RolesController", controllerGroup: "Roles", action: "Get", method: "GET", path: "/roles",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "RoutingMatrix_List_GET_253", controller: "RoutingMatrixController", controllerGroup: "RoutingMatrix", action: "List", method: "GET", path: "/routing",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "RoutingMatrix_Upsert_POST_254", controller: "RoutingMatrixController", controllerGroup: "RoutingMatrix", action: "Upsert", method: "POST", path: "/routing",
    params: [{"name": "request", "type": "RoutingRuleUpsertRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "RuntimeContract_FrontendStatus_GET_255", controller: "RuntimeContractController", controllerGroup: "RuntimeContract", action: "FrontendStatus", method: "GET", path: "/runtime-contract/frontend-contract-status",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "RuntimeContract_Routes_GET_256", controller: "RuntimeContractController", controllerGroup: "RuntimeContract", action: "Routes", method: "GET", path: "/runtime-contract/routes",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "RuntimeContract_Schemas_GET_257", controller: "RuntimeContractController", controllerGroup: "RuntimeContract", action: "Schemas", method: "GET", path: "/runtime-contract/schemas",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "RuntimeContract_SwaggerStatus_GET_258", controller: "RuntimeContractController", controllerGroup: "RuntimeContract", action: "SwaggerStatus", method: "GET", path: "/runtime-contract/swagger-status",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "runtime-readiness", risk: "readiness",
  },
  {
    key: "ScheduledJobs_List_GET_259", controller: "ScheduledJobsController", controllerGroup: "ScheduledJobs", action: "List", method: "GET", path: "/scheduled-jobs",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ScheduledJobs_Upsert_POST_260", controller: "ScheduledJobsController", controllerGroup: "ScheduledJobs", action: "Upsert", method: "POST", path: "/scheduled-jobs",
    params: [{"name": "request", "type": "ScheduledJobDefinitionRequest", "required": true}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ScheduledJobs_Start_POST_261", controller: "ScheduledJobsController", controllerGroup: "ScheduledJobs", action: "Start", method: "POST", path: "/scheduled-jobs/{id}/start",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "correlationId", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "ScheduledJobs_Complete_POST_262", controller: "ScheduledJobsController", controllerGroup: "ScheduledJobs", action: "Complete", method: "POST", path: "/scheduled-jobs/runs/{runId}/complete",
    params: [{"name": "runId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "recordsProcessed", "type": "Int32", "required": false}, {"name": "errorMessage", "type": "String", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "SecurityLogs_Get_GET_263", controller: "SecurityLogsController", controllerGroup: "SecurityLogs", action: "Get", method: "GET", path: "/security-logs",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "operations-intelligence", risk: "support",
  },
  {
    key: "Sla_Profiles_GET_264", controller: "SlaController", controllerGroup: "Sla", action: "Profiles", method: "GET", path: "/sla/profiles",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Sla_Rules_GET_265", controller: "SlaController", controllerGroup: "Sla", action: "Rules", method: "GET", path: "/sla/rules",
    params: [{"name": "profileId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Sod_Policies_GET_266", controller: "SodController", controllerGroup: "Sod", action: "Policies", method: "GET", path: "/sod/policies",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Tags_Get_GET_267", controller: "TagsController", controllerGroup: "Tags", action: "Get", method: "GET", path: "/tags",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "categoryId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Tasks_Accept_POST_268", controller: "TasksController", controllerGroup: "Tasks", action: "Accept", method: "POST", path: "/tasks/{id}/accept",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Tasks_Assign_POST_269", controller: "TasksController", controllerGroup: "Tasks", action: "Assign", method: "POST", path: "/tasks/{id}/assign",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "userId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}, {"name": "roleId", "type": "0, Culture=neutral, PublicKeyToken=7cec85d7bea7798e]]", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Tasks_Complete_POST_270", controller: "TasksController", controllerGroup: "Tasks", action: "Complete", method: "POST", path: "/tasks/{id}/complete",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "remarks", "type": "String", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Tasks_Reopen_POST_271", controller: "TasksController", controllerGroup: "Tasks", action: "Reopen", method: "POST", path: "/tasks/{id}/reopen",
    params: [{"name": "id", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}, {"name": "reason", "type": "String", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Tasks_ForComplaint_GET_272", controller: "TasksController", controllerGroup: "Tasks", action: "ForComplaint", method: "GET", path: "/tasks/complaint/{complaintId}",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Tasks_My_GET_273", controller: "TasksController", controllerGroup: "Tasks", action: "My", method: "GET", path: "/tasks/my",
    params: [{"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Users_Get_GET_274", controller: "UsersController", controllerGroup: "Users", action: "Get", method: "GET", path: "/users",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "admin-governance", risk: "admin",
  },
  {
    key: "Verification_Approve_POST_275", controller: "VerificationController", controllerGroup: "Verification", action: "Approve", method: "POST", path: "/verification/complaint/{complaintId}/{verificationId}/approve",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "verificationId", "type": "Guid", "required": true}, {"name": "request", "type": "VerificationDecisionRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Verification_Reject_POST_276", controller: "VerificationController", controllerGroup: "Verification", action: "Reject", method: "POST", path: "/verification/complaint/{complaintId}/{verificationId}/reject",
    params: [{"name": "complaintId", "type": "Guid", "required": true}, {"name": "verificationId", "type": "Guid", "required": true}, {"name": "request", "type": "VerificationDecisionRequest", "required": true}, {"name": "tenantId", "type": "Guid", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Verification_Prepare_POST_277", controller: "VerificationController", controllerGroup: "Verification", action: "Prepare", method: "POST", path: "/verification/prepare",
    params: [{"name": "request", "type": "VerificationPrepareRequest", "required": true}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Workflow_Actions_GET_278", controller: "WorkflowController", controllerGroup: "Workflow", action: "Actions", method: "GET", path: "/workflow/actions",
    params: [{"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Workflow_Profiles_GET_279", controller: "WorkflowController", controllerGroup: "Workflow", action: "Profiles", method: "GET", path: "/workflow/profiles",
    params: [{"name": "tenantId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Workflow_Statuses_GET_280", controller: "WorkflowController", controllerGroup: "Workflow", action: "Statuses", method: "GET", path: "/workflow/statuses",
    params: [{"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
  {
    key: "Workflow_Transitions_GET_281", controller: "WorkflowController", controllerGroup: "Workflow", action: "Transitions", method: "GET", path: "/workflow/transitions",
    params: [{"name": "profileId", "type": "Guid", "required": false}, {"name": "activeOnly", "type": "Boolean", "required": false}],
    frontendArea: "case-lifecycle", risk: "core",
  },
] as const satisfies readonly CmtsBackendEndpoint[];
export type CmtsBackendEndpointKey = typeof CMTS_BACKEND_ENDPOINTS[number]["key"];
export const CMTS_BACKEND_ENDPOINT_BY_KEY: Record<string, CmtsBackendEndpoint> = Object.fromEntries(CMTS_BACKEND_ENDPOINTS.map((endpoint) => [endpoint.key, endpoint])) as Record<string, CmtsBackendEndpoint>;
export const CMTS_BACKEND_CONTROLLER_GROUPS = [...new Set(CMTS_BACKEND_ENDPOINTS.map((endpoint) => endpoint.controllerGroup))].sort();
export function getCmtsEndpointsByController(controllerGroup: string): readonly CmtsBackendEndpoint[] { return CMTS_BACKEND_ENDPOINTS.filter((endpoint) => endpoint.controllerGroup === controllerGroup); }
export function getCmtsEndpointsByArea(frontendArea: string): readonly CmtsBackendEndpoint[] { return CMTS_BACKEND_ENDPOINTS.filter((endpoint) => endpoint.frontendArea === frontendArea); }